"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pictureConfigs = void 0;
exports.pictureConfigs = {
    // represents configs for Picture Component, object keys - Umbraco container title
    6: {
        mode: 'crop',
        width: 515,
        parameters: [
            {
                width: 450,
                maxWidth: 479,
            },
            {
                width: 740,
                maxWidth: 767,
            },
            {
                width: 465,
                maxWidth: 991,
            },
            {
                width: 450,
                maxWidth: 1199,
            },
        ],
        thumbnails: {
            width: 150,
            parameters: [
                {
                    width: 65,
                    maxWidth: 991,
                },
            ],
        },
    },
    12: {
        mode: 'crop',
        width: 1050,
        parameters: [
            {
                width: 480,
                maxWidth: 479,
            },
            {
                width: 768,
                maxWidth: 767,
            },
            {
                width: 520,
                maxWidth: 991,
            },
            {
                width: 680,
                maxWidth: 1199,
            },
        ],
        thumbnails: {
            width: 150,
            parameters: [
                {
                    width: 65,
                    maxWidth: 991,
                },
            ],
        },
    },
};
